import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DeliveredProcedureOutlinedSvg from "@ant-design/icons-svg/es/asn/DeliveredProcedureOutlined";
import AntdIcon from "../components/AntdIcon";
var DeliveredProcedureOutlined = function DeliveredProcedureOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DeliveredProcedureOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DeliveredProcedureOutlined.displayName = 'DeliveredProcedureOutlined';
}
export default /*#__PURE__*/React.forwardRef(DeliveredProcedureOutlined);